var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sectionBox"},[(_vm.valueStr === "0")?_c('span',[_vm._v("关")]):(_vm.valueStr === "1")?_c('span',[_vm._v("开")]):_c('span',[_vm._v(" "+_vm._s(_vm.valueStr))])])}
var staticRenderFns = []

export { render, staticRenderFns }